import { reveal } from "@components/animations";
import { ForwardBtn, SkillsCard } from "@components/shared";
import { mySkills } from "@demo-data/skills";
import { Stack } from "@mui/system";

export default function Skills() {
  return (
    <Stack gap={4}>
      <ForwardBtn title="Skills" isShowBackBtn={false} />
      <div className="anim-card-grid">
        {mySkills?.map((skill, index) => (
          <div key={index} {...reveal("up", index * 55)}>
            <SkillsCard title={skill?.title} skills={skill?.items} />
          </div>
        ))}
      </div>
    </Stack>
  );
}
